import { createActions } from 'redux-actions';

import types from 'state/direct-order-recurring/range/actionTypes';

const { directOrderRecurring } = createActions({
  [types.SET_RANGE]: ({ type, value }) => ({ type, value }),
});

export default directOrderRecurring;
